import App from "./ConfiguraAdvance.svelte";
const initConfig = {
    mainTitle: "Customize your Accora Configura Advance",
    bookADemoHref: "https://accora.care/book-a-join-visit",
};
export const ConfiguraAdvance = (targetId, config) => {
    const app = new App({
        target: document.getElementById(targetId),
        props: {
            config: Object.assign(Object.assign({}, initConfig), config),
        },
    });
    return app;
};
window.ConfiguraAdvance = ConfiguraAdvance;
export default ConfiguraAdvance;
